import * as React from 'react'
import { FC, useMemo } from 'react'

import { EditLeadNoteFormWrapper } from './EditLeadNoteFormWrapper'
import { EditOpportunityNoteFormWrapper } from './EditOpportunityNoteFormWrapper'
import { ENTITY_TYPES } from '@sales-center/common'
import { ActionModal } from '@sales-center/components'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  noteId: number
  onClose: () => void
  onUpdateSuccess: () => void
  onGoBack?: () => void
  open: boolean
  backToNotes?: boolean
  externalLinkId?: string
}

export const EditNoteDrawer: FC<Props> = (props) => {
  const {
    entityId,
    entityType,
    noteId,
    onClose,
    onUpdateSuccess,
    onGoBack,
    open,
    backToNotes,
    externalLinkId,
  } = props

  const getNoteForm = useMemo(() => {
    return (
      <>
        {entityType == ENTITY_TYPES.Lead && (
          <EditLeadNoteFormWrapper
            leadId={entityId}
            noteId={noteId}
            onClose={onClose}
            onUpdateSuccess={onUpdateSuccess}
            externalLinkId={externalLinkId}
            onGoBack={onGoBack}
          />
        )}

        {entityType == ENTITY_TYPES.Opportunity && (
          <EditOpportunityNoteFormWrapper
            noteId={noteId}
            onClose={onClose}
            onUpdateSuccess={onUpdateSuccess}
            opportunityId={entityId}
            externalLinkId={externalLinkId}
            onGoBack={onGoBack}
          />
        )}
      </>
    )
  }, [entityType, noteId, onClose, entityId, externalLinkId])

  return (
    <ActionModal
      title={'Notes'}
      onClose={onClose}
      open={open}
      backIcon={backToNotes}
      onGoBack={onGoBack}
      customContinerWidth={{
        xs: '90vw',
        md: '50vw',
      }}
      disableBackdropClick
    >
      {getNoteForm}
    </ActionModal>
  )
}

EditNoteDrawer.displayName = 'EditNoteDrawer'
